import React, { useEffect, useState } from "react";
import { setLevel2SliderProperty } from "../../../WorkbookSlice";
import { useDispatch } from "react-redux";

export default function SliderComp({
  ControllerProps,
  dispatchItemToredux,
  defaultValue: reduxValue,
}) {
  const { title, minValue, maxValue, reduxKey, defaultValue } = ControllerProps;
  // console.log(defaultValue);
  // console.log(reduxValue);

  const [sliderValue, setSliderValue] = useState(defaultValue);
  useEffect(() => {
    setSliderValue(reduxValue);
  }, [reduxValue]);
  // console.log(sliderValue);
  const handleValueChange = (newValue) => {
    let numValue = Number(newValue);
    // console.log(numValue);
    setSliderValue(numValue);
    setTimeout(() => {
      dispatchItemToredux(Number(numValue), reduxKey);
    }, 1000);
  };

  return (
    <div className="flex flex-col items-start justify-center w-full">
      <label
        htmlFor={reduxKey}
        className="w-full font-light text-black text-sm truncate"
      >
        {title}
      </label>
      <div className="w-full flex items-center justify-start gap-x-4">
        <input
          type="range"
          id={reduxKey}
          min={minValue}
          max={maxValue}
          value={reduxValue}
          onChange={(e) =>
            dispatchItemToredux(Number(e.target.value), reduxKey)
          }
          className="slider-input w-[70%] appearance-none h-2 rounded-lg outline-none cursor-pointer"
        />
        <input
          type="text"
          value={sliderValue}
          onChange={(e) => {
            const newValue = e.target.value;
            // Allow only numbers
            if (/^\d*$/.test(newValue)) {
              handleValueChange(newValue);
            }
          }}
          className="w-[20%] border px-1 py-[2px] text-sm text-center rounded focus:outline-none"
        />
      </div>
    </div>
  );
}
